module.exports = __webpack_public_path__ + "static/media/24.7b299425.jpg";